import { render, staticRenderFns } from "./HeirloomBoost.vue?vue&type=template&id=1ac7331f"
import script from "./HeirloomBoost.vue?vue&type=script&lang=js"
export * from "./HeirloomBoost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports